(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-guide-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pomad-guide-carousel')) {
    customElements.define('pomad-guide-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        const track = this.querySelector('.article-guide-track');
        const controls = this.querySelector('.article-guide-controls');
        if (!track || !controls || !this.hasAttribute('data-carousel')) return;
        const buttons = Array.from(controls.querySelectorAll('button'));
        const update = () => {
          const rtl = getComputedStyle(track).direction === 'rtl';
          const offset = Math.abs(track.scrollLeft);
          controls.hidden = track.scrollWidth <= track.clientWidth + 2;
          buttons[0].disabled = offset < 2;
          buttons[1].disabled = offset >= track.scrollWidth - track.clientWidth - 2;
          this.rtl = rtl;
        };
        const move = direction => {
          const first = track.firstElementChild;
          const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
          track.scrollBy({ left: direction * step * (this.rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), { signal }));
        track.addEventListener('scroll', update, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth * (this.rtl ? -1 : 1) });
          else move((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
        }, { signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["article-guide-tables"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pomad-guide-tables')) {
    customElements.define('pomad-guide-tables', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = new AbortController();
        this.observer = new ResizeObserver(entries => {
          entries.forEach(({ target }) => {
            const overflow = target.scrollWidth > target.clientWidth + 2;
            target.tabIndex = overflow ? 0 : -1;
            const hint = document.getElementById(target.dataset.hintId);
            if (hint) {
              hint.hidden = !overflow;
              hint.classList.toggle('oa-hidden', !overflow);
              target.classList.toggle('!oa-mt-0', overflow);
            }
          });
        });
        this.querySelectorAll('table').forEach((table, index) => {
          let wrap = table.closest('.article-table-wrap');
          if (!wrap && table.parentElement.classList.contains('table-wrapper')) {
            wrap = table.parentElement;
            wrap.classList.add('article-table-wrap');
          }
          if (!wrap) {
            wrap = document.createElement('div');
            wrap.className = 'article-table-wrap';
            table.before(wrap);
            wrap.append(table);
          }
          wrap.classList.add(...'!oa-max-w-full !oa-overscroll-x-contain ![scrollbar-width:thin] !oa-my-6 !oa-mx-0 !oa-overflow-x-auto !oa-border !oa-border-solid !oa-border-[#dcded4] !oa-rounded-[10px] focus-visible:oa-outline focus-visible:oa-outline-2 focus-visible:oa-outline-current focus-visible:oa-outline-offset-2'.split(' '));
          table.classList.add('article-table', ...'!oa-table !oa-w-full !oa-min-w-[var(--guide-table-min,420px)] !oa-max-w-none !oa-table-auto !oa-overflow-visible !oa-m-0 !oa-border-collapse !oa-text-[16px] !oa-leading-[1.55]'.split(' '));
          table.querySelectorAll('caption').forEach(cell => cell.classList.add(...'!oa-py-4 !oa-px-5 !oa-text-left !oa-bg-[#f3f4ed] !oa-font-semibold'.split(' ')));
          table.querySelectorAll('th, td').forEach(cell => cell.classList.add(...'!oa-min-w-[10rem] !oa-py-[18px] !oa-px-5 !oa-text-left !oa-align-top !oa-whitespace-normal !oa-border-0 !oa-border-t !oa-border-solid !oa-border-t-[#dcded4] max-md:!oa-py-3.5 max-md:!oa-px-3 max-md:!oa-text-[14px]'.split(' ')));
          table.querySelectorAll('th').forEach(cell => cell.classList.add(...'!oa-font-semibold !oa-bg-[#fafbf6]'.split(' ')));
          const columns = Math.max(1, ...Array.from(table.rows, row => Array.from(row.cells).reduce((sum, cell) => sum + cell.colSpan, 0)));
          table.style.setProperty('--guide-table-min', `${columns > 2 ? columns * 200 : 420}px`);
          wrap.querySelectorAll('.table-wrapper').forEach(inner => inner.classList.add('!oa-overflow-visible'));
          wrap.setAttribute('role', 'region');
          if (!wrap.hasAttribute('aria-label') && !wrap.hasAttribute('aria-labelledby')) {
            wrap.setAttribute('aria-label', table.caption?.textContent?.trim() || this.dataset.label);
          }
          if (!wrap.dataset.hintId) {
            const hint = document.createElement('p');
            hint.id = `${this.closest('[data-section-id]').id}-table-hint-${index + 1}`;
            hint.className = 'article-table-hint !oa-text-[13px] !oa-leading-[1.5] !oa-mt-0 !oa-mb-[1.1em]';
            hint.textContent = this.dataset.hint;
            hint.hidden = true;
            wrap.before(hint);
            wrap.dataset.hintId = hint.id;
            wrap.setAttribute('aria-describedby', hint.id);
          }
          wrap.addEventListener('keydown', event => {
            if (event.target !== wrap || event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const rtl = getComputedStyle(wrap).direction === 'rtl';
            if (event.key === 'Home' || event.key === 'End') {
              wrap.scrollTo({ left: event.key === 'Home' ? 0 : wrap.scrollWidth * (rtl ? -1 : 1) });
            } else {
              wrap.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * wrap.clientWidth * .75 });
            }
          }, { signal: this.controller.signal });
          this.observer.observe(wrap);
        });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["article-product-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
    const installed = Symbol.for('pomad.articleProductTracking');
    const articleSelector = '[data-article-id][data-article-shop-url]';
    if (window[installed] || window.Shopify?.designMode || !document.querySelector(articleSelector)) return;
    window[installed] = true;

    let privacyRequested = false;
    function loadPrivacy() {
      const shopify = window.Shopify;
      if (privacyRequested || shopify?.customerPrivacy?.analyticsProcessingAllowed || !shopify?.loadFeatures) return;
      privacyRequested = true;
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (error) privacyRequested = false;
        });
      } catch {
        privacyRequested = false;
      }
    }

    function productHandle(link, article) {
      try {
        const url = new URL(link.getAttribute('href'), document.baseURI);
        const shopOrigin = new URL(article.dataset.articleShopUrl).origin;
        if (!['http:', 'https:'].includes(url.protocol)) return null;
        if (url.origin !== location.origin && url.origin !== shopOrigin) return null;
        const match = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[^/]+\/)?products\/([^/]+)\/?$/i);
        return match ? decodeURIComponent(match[1]) : null;
      } catch {
        return null;
      }
    }

    function placementFor(link, content) {
      const marked = link.closest('[data-article-link-placement]');
      if (marked && content.contains(marked)) {
        const placement = marked.dataset.articleLinkPlacement;
        if (['body', 'product_card', 'end_cta'].includes(placement)) return placement;
      }
      return link.closest('.article-products') ? 'product_card' : 'body';
    }

    function onClick(event) {
      if (event.defaultPrevented || window.Shopify?.designMode) return;
      if (event.type === 'click' ? event.button !== 0 : event.button !== 1) return;
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const link = target?.closest('a[href]');
      const content = link?.closest('[data-article-content]');
      const article = content?.closest(articleSelector);
      if (!article?.dataset.articleId || link.hasAttribute('download')) return;
      const handle = productHandle(link, article);
      if (!handle) return;

      loadPrivacy();
      const shopify = window.Shopify;
      try {
        if (shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
        if (typeof shopify.analytics?.publish !== 'function') return;
        const placement = placementFor(link, content);
        const links = Array.from(content.querySelectorAll('a[href]')).filter(candidate =>
          !candidate.hasAttribute('download') && productHandle(candidate, article) && placementFor(candidate, content) === placement
        );
        const payload = {
          article_id: article.dataset.articleId,
          product_handle: handle,
          link_placement: placement,
          link_id: link.dataset.articleLinkId || `${placement}-${links.indexOf(link) + 1}`
        };
        const published = shopify.analytics.publish('pomad:article_product_click', payload);
        Promise.resolve(published).catch(() => {});
      } catch {}
    }

    loadPrivacy();
    document.addEventListener('click', onClick);
    document.addEventListener('auxclick', onClick);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-styles"] && !Shopify.designMode) return;
  try {
    ;(() => {
		const preference = matchMedia('(prefers-reduced-motion: reduce)')
		if (!('IntersectionObserver' in window)) return
		const seen = new WeakSet()
		const observer = new IntersectionObserver(
			entries =>
				entries.forEach(entry => {
					if (!entry.isIntersecting) return
					observer.unobserve(entry.target)
					if (!preference.matches && !window.Shopify?.designMode)
						entry.target.animate(
							[
								{ opacity: 0.6, transform: 'translateY(12px)' },
								{ opacity: 1, transform: 'none' }
							],
							{ duration: 420, easing: 'ease-out' }
						)
				}),
			{ threshold: 0.12 }
		)
		function scan(root) {
			root.querySelectorAll('.lp-product-grid > article, .lp-guide, .lp-section-heading').forEach(element => {
				if (seen.has(element)) return
				seen.add(element)
				observer.observe(element)
			})
		}
		scan(document)
		document.addEventListener('shopify:section:load', event => scan(event.target))
		document.addEventListener('shopify:section:unload', event => {
			event.target.querySelectorAll('.lp-product-grid > article, .lp-guide, .lp-section-heading').forEach(element => observer.unobserve(element))
		})
	})()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oa-product-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oa-deferred-animation')) {
    customElements.define('oa-deferred-animation', class extends HTMLElement {
      connectedCallback() {
        const image = this.querySelector('img[data-animation-src]');
        if (!image || !('IntersectionObserver' in window)) return;

        this.attempts = 0;
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting && entry.intersectionRatio > 0)) return;
          this.observer.disconnect();
          this.loadAnimation(image);
        }, { threshold: 0.01 });
        this.observer.observe(image);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        clearTimeout(this.retryTimer);
        if (this.pendingImage) {
          this.pendingImage.onload = null;
          this.pendingImage.onerror = null;
          this.pendingImage = null;
        }
      }

      loadAnimation(image) {
        const animation = new Image();
        this.pendingImage = animation;
        this.attempts += 1;
        animation.onload = () => {
          if (!this.isConnected) return;
          animation.onload = null;
          for (const attribute of image.attributes) {
            if (['src', 'srcset', 'sizes', 'loading', 'data-animation-src', 'data-animation-srcset'].includes(attribute.name)) continue;
            animation.setAttribute(attribute.name, attribute.value);
          }
          image.replaceWith(animation);
          this.pendingImage = null;
        };
        animation.onerror = () => {
          this.pendingImage = null;
          // Une seule nouvelle tentative : un GIF de plusieurs Mo échoue
          // parfois sur mobile, l'affiche fixe ne doit pas rester définitive.
          if (this.attempts >= 2 || !this.isConnected) return;
          this.retryTimer = setTimeout(() => {
            if (this.isConnected && image.isConnected) this.loadAnimation(image);
          }, 2000);
        };
        animation.sizes = image.sizes;
        animation.srcset = image.dataset.animationSrcset;
        animation.src = image.dataset.animationSrc;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
